<template>
<div class="panal mt-20">
<div class="panal-header">Education </div>

<div class="table-responsive p-3">
<table class="table table-hover table-bordered">
  <thead class="thead-light">
    <tr>
      <th scope="col" >CERTIFICATION</th>
      <th scope="col" >SPECIALIZATION</th>
      <th scope="col" >DEGREE</th>
      <th scope="col" >PERCENTAGE</th>
      
      <th scope="col" >CERTIFICATION YEAR</th>
    </tr>
  </thead>
  <tbody>
     <tr v-if="empty"><td colspan="5"> No Data </td></tr>
    <tr v-for="Certificate in ApplicantCertificate" v-bind:key="Certificate.serial">
     <td>{{Certificate.CertificationNameEN}}</td>
     <td>{{Certificate.SpecializationNameEN}}</td>
     <td>{{Certificate.Degree}}</td>
     <td>{{Certificate.Percentage}}</td>
     <td>{{Certificate.Year}}</td>
     
    </tr>
   
    <tr class="table-borderless">
            <td  align="left" colspan="2">
            <span class="text-left">Select Certification</span>
               <select v-validate="'required|excluded:0'" name="certification" class="form-control w-100 su-border" v-b-tooltip.hover title="Select Certification"  v-model="ApplicantCertifications.CertificateTypeID"  @change="handleSpcialization()">
                  <option selected value="0">Choose</option>
                   <option v-for="Certtificate in Certifications" :value="Certtificate.serial" v-bind:key="Certtificate.serial" >{{Certtificate.CertificationNameEN}}</option>
                 </select>
                 <div v-if="submitted && errors.has('certification')" class="alert-danger">{{errors.first('certification')}}</div>

            </td>
            <td align="left" colspan="2">
            <span>Specialization</span>
               <select v-validate="'required|excluded:0'" name="specialization" class="form-control w-100 su-border" v-b-tooltip.hover title="Select Specialization"  v-model="ApplicantCertifications.SpecializationTypeID">
         <option selected value="0">Choose</option>
          <option v-for="Special in CertificationsSpecialization" :value="Special.Serial" v-bind:key="Special.Serial" >{{Special.SpecializationNameEN}}</option>

    </select>
               <div v-if="submitted && errors.has('specialization')" class="alert-danger">{{errors.first('specialization')}}</div>

            </td>
            <td align="left" colspan="2">
            <span>Year</span>
              <select v-validate="'required|excluded:0'" name="year" class="form-control w-100 su-border" v-b-tooltip.hover title="Select Year"  v-model="ApplicantCertifications.YearID">
             <option selected value="0">Choose</option>
               <option v-for="Year in Years" :value="Year.Serial" v-bind:key="Year.Serial" >{{Year.Year}}</option>

           </select>
           <div v-if="submitted && errors.has('year')" class="alert-danger">{{errors.first('year')}}</div>

            </td>
          
        </tr>
        <tr class="table-borderless">
          <td align="left" colspan="2">
            <span>Degree</span>
               <input v-validate="'required|excluded:0'" name="degree" type="number" step=".01" class="form-control w-100 su-border" v-b-tooltip.hover title="Degree"   v-model="ApplicantCertifications.Degree"/>
                    <div v-if="submitted && errors.has('degree')" class="alert-danger">{{errors.first('degree')}}</div>

            </td>
            <td align="left" colspan="2">
            <span>Percerntage</span>
               <input v-validate="'required|excluded:0'" name="percentage" type="number" step=".01" class="form-control w-100 su-border" v-b-tooltip.hover title="Percentage"   v-model="ApplicantCertifications.Percentage"/>
                    <div v-if="submitted && errors.has('percentage')" class="alert-danger">{{errors.first('percentage')}}</div>

            </td>
             <td colspan="5" style="text-align: left;">
           <br/>
                <button type="button" class="btn btn-block btn-primary btn-sm" id="addrow"  @click="handleEducation()" :disabled="loading">
                       <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                      Add Education</button>
            </td>
        </tr>
  </tbody>
</table>

   <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>

</div>



</div>


</template>

<script>
import {Certifications ,CertificationsSpecialization ,ApplicantCertifications ,Years  } from '../../models/Applicant';
import ApplicantServices from '../../services/Applicant/Applicant.service' ;
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services' ;
export default {
        name: 'Education',
        data(){
          return{
          Certifications : new Certifications('','','','','',''),
           CertificationsSpecialization : new CertificationsSpecialization('','',''),
           ApplicantCertifications : new ApplicantCertifications(0,0,0,0.0,0.0,0),
           ApplicantCertificate : [],
           Years : new Years('','',''),
            submitted:false,
            loading: false,
            successful: false,
            message:'',
            empty:false
          }
        },
        computed:{
          currenUser(){
            return  this.$store.state.auth.user
          },
         reviewApplication(){
       return  this.$store.state.auth.renderReview 

        
       }
        },
        mounted(){
          ApplicantServices.CertificationTypeSelectAll().then(Response =>{
          this.Certifications=Response.data
        }, error => {
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            }),
             ApplicantServices.GetCertificationYears().then(Response =>{
           this.Years=Response.data
          }, error => {
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            })

           ApplicantDataServices.GetCerificationData(this.currenUser.UserIDSerial).then(Response =>{
           this.ApplicantCertificate = Response.data 
          }, error => {
            
                   this.empty = true
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                if(error.response.status == 404) this.message =''
            }) 
            
        },
        methods:{
          handleSpcialization(){
         
          ApplicantServices.GetCertificationSpecialization(this.ApplicantCertifications.CertificateTypeID).then(Response =>{
          this.CertificationsSpecialization=Response.data
        }, error => {
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            })
          
          },
          handleEducation(){
            this.submitted = true
            this.ApplicantCertifications.ApplicantID = this.currenUser.UserIDSerial
         this.$validator.validate().then(isValid => {
          if (isValid) {
                        this.loading = true;
           this.$store.dispatch('auth/Review', this.reviewApplication+1 )

            ApplicantDataServices.PostEducationHistoryInsert(this.ApplicantCertifications).then( data => {
                 this.message= data.data 
                 this.successful = true;
                 this.empty = false
                this.loading = false;
                  ApplicantDataServices.GetCerificationData(this.currenUser.UserIDSerial).then(Response =>{
           this.ApplicantCertificate = Response.data 
          })
                }).catch(Response=>{
                  this.successful = false;
                  this.loading = false;
                 
                 
                   this.message = Response.response.data.Message
                  
                 
                } 
                
               
                ),
              error => {
           
               this.ApplicantCertifications = (0,0,0,0.0,0.0,0)
               this.message =
               (error.response && error.response.data && error.response.data.Message) ||
                 error.message ||  
                   error.toString();
               
              }
          }})
          }
        }
    } 
</script>

<style scoped>
 
.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
    border: 1px solid #d4d4d4;
padding:0px 0px 20px 0px;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.mt-20{
  margin-top:20px;
}
.mt-40{
  margin-top:40px;
}

th{
font-weight:bold;
font-size: 12px;
}
td{
  font-size: 14px;
}
.su-border {
    border-color: #3D8FE3 !important;
    background: #F1F9FF !important;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>